export default __webpack_public_path__ + "static/imgg3-2689f58cb14d1d77639f6cd436a8a158.jpg";